export default __webpack_public_path__ + "static/media/img3.78b0c858.jpg";